import React from 'react';

import BaseCheckbox from '$partials/fields/checkbox.jsx';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/partials/filters/individual.d.ts').Checkbox}
 */
export const Checkbox = (props) => {
    return (
        <fieldset className='flex w-full justify-between gap-16 h-[44px] items-center'>
            <legend className='sr-only'>{props.label}</legend>
            <div
                aria-hidden={true}
                className='type-style-eyebrow'>
                {props.label}
            </div>
            <div>
                <BaseCheckbox {...props} />
            </div>
        </fieldset>
    );
};

/* ========================================================================= */
/* Export(s) */
/* ========================================================================= */

export default Checkbox;
